import { render, staticRenderFns } from "./OrderablePreviewItemExtras.vue?vue&type=template&id=0353c0ec&"
import script from "./OrderablePreviewItemExtras.vue?vue&type=script&lang=ts&"
export * from "./OrderablePreviewItemExtras.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports